/**
 * Weblog from LCR does not contain any linked galleries, but AC's old data almost certainly does.
 *
 * @module
 * @format
 */

import {ENUM, INTEGER, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {FSK_LEVEL} from './fsk.js';
import {LANGUAGE} from './lang.js';

const WEBLOG_MEDIA_TYPE_MOVIE = 'movie';
const WEBLOG_MEDIA_TYPE_PICTURE = 'picture';

/**
 * @type {['movie', 'picture']}
 */
const TYPE_LIST = [WEBLOG_MEDIA_TYPE_MOVIE, WEBLOG_MEDIA_TYPE_PICTURE];

const asWeblogMediaType = /* @__PURE__ */ ENUM(TYPE_LIST);

const asWeblogData = /* @__PURE__ */ OBJECT({
  id: INTEGER,
  user_id: STRING,
  created: STRING,
  published: STRING,
  language: LANGUAGE,
  title: STRING,
  content: STRING,
  image: /* @__PURE__ */ OPTIONAL(STRING),
  image_fsk: /* @__PURE__ */ OPTIONAL(FSK_LEVEL),
  set_id: /* @__PURE__ */ OPTIONAL(INTEGER),
  media_type: /* @__PURE__ */ OPTIONAL(asWeblogMediaType),
  media_id: /* @__PURE__ */ OPTIONAL(INTEGER),
});

export {asWeblogData, WEBLOG_MEDIA_TYPE_MOVIE, WEBLOG_MEDIA_TYPE_PICTURE};
